import React, { useState } from "react";
import { withApollo } from "react-apollo";
import queries from "../../../queries";

// Editing the rows of an Agenda Tableau cell: pick a day, then add/edit/delete its rows. Each row has
// one text value per active column (cell.columns_count, 2 to 5), matching the column titles set in the
// "Colonnes" section of the cell editor.

const COLUMN_KEYS = ['column_1', 'column_2', 'column_3', 'column_4', 'column_5'];

const dayLabel = (day) => {
  const [year, month, date] = day.date.slice(0, 10).split('-');
  return `${date}.${month}.${year}`;
};

function columnTitles(cell) {
  const count = Math.min(Math.max(cell.columns_count || 2, 2), 5);
  return COLUMN_KEYS.slice(0, count).map((key, i) => [key, cell[`column_${i + 1}_title`] || `Colonne ${i + 1}`]);
}

function RowForm({ row, columns, onSave, onDelete }) {
  const [form, setForm] = useState(() => {
    const initial = {};
    columns.forEach(([key]) => { initial[key] = row[key] || ''; });
    return initial;
  });
  const [state, setState] = useState('');
  const set = (key, value) => { setForm((previous) => ({ ...previous, [key]: value })); setState(''); };

  const save = async () => {
    setState('Enregistrement…');
    try {
      await onSave({ id: row.id, ...form });
      setState('Enregistré');
    } catch (error) {
      setState('Erreur : ' + error.message);
    }
  };

  return (
    <div style={{ border: '1px solid var(--tsk-border)', borderRadius: 4, marginBottom: 8, padding: '8px 10px', background: 'var(--tsk-bg-card)', color: 'var(--tsk-text)' }}>
      {columns.map(([key, title]) => (
        <div className="tsk-input-line" key={key}>
          <label>{title}</label>
          <input type="text" value={form[key]} onChange={(e) => set(key, e.target.value)} />
        </div>
      ))}
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginTop: 8 }}>
        <button type="button" className="tsk-button" onClick={save}>Enregistrer</button>
        <button
          type="button" className="tsk-button"
          onClick={() => { if (window.confirm('Supprimer cette ligne ?')) onDelete(); }}
        >
          Supprimer
        </button>
        <span>{state}</span>
      </div>
    </div>
  );
}

function AgendaTableauRowsEditor({ cell, refetch, client }) {
  const days = [...cell.days].sort((a, b) => a.date.localeCompare(b.date));
  const [pickedDay, setPickedDay] = useState(null);
  const dayId = days.some((day) => day.id === pickedDay) ? pickedDay : (days[0] && days[0].id);
  const columns = columnTitles(cell);

  if (days.length === 0) {
    return <p>Aucun jour pour l'instant : ajoute un jour dans la section « Jours », ou importe un CSV.</p>;
  }

  const rows = cell.rows
    .filter((row) => row.agenda_tableau_day_id === dayId)
    .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));

  const run = async (mutation, variables) => {
    await client.mutate({ mutation, variables });
    await refetch();
  };

  const add = async () => {
    await client.mutate({
      mutation: queries.cells.agenda_tableau.addRow,
      variables: { input: { cell_id: cell.id, agenda_tableau_day_id: dayId, sort_order: rows.length } },
    });
    await refetch();
  };

  return (
    <div>
      <div className="tsk-input-line">
        <label>Jour</label>
        <select value={dayId} onChange={(e) => setPickedDay(e.target.value)}>
          {days.map((day) => <option key={day.id} value={day.id}>{dayLabel(day)}</option>)}
        </select>
      </div>
      {rows.length === 0 && <p>Aucune ligne ce jour-là.</p>}
      {rows.map((row) => (
        <RowForm
          key={[row.id, ...columns.map(([key]) => row[key])].join('|')}
          row={row}
          columns={columns}
          onSave={(input) => run(queries.cells.agenda_tableau.updateRow, { input })}
          onDelete={() => run(queries.cells.agenda_tableau.deleteRow, { id: row.id })}
        />
      ))}
      <button type="button" className="tsk-button" onClick={add}>Ajouter une ligne</button>
    </div>
  );
}

export default withApollo(AgendaTableauRowsEditor);
